export const APP_VERSION = 'dev-v2.2.47';
